<script setup lang="ts">
    import { __ } from '@/js/stores/expressions';
    import TextInput, { TextInputWidth } from '../TextInput.vue';
    import { useWidgetFormStore } from '@/js/stores/widgetForm';
    import { ICreateWidget } from '@/js/services/api/widget/types';
    import TextareaInput from '../TextareaInput.vue';
    import MarkdownTextarea from '../MarkdownTextarea.vue';
    import InputLabel from '../InputLabel.vue';
    import FormGroup from '../FormGroup.vue';

    const formStore = useWidgetFormStore();
</script>
<template>
    <FormGroup>
        <div>
            <InputLabel for="widget-form-name-input-title">
                {{ __('widget-form-name-input-title') }}
            </InputLabel>
            <TextInput
                id="widget-form-name-input-title"
                v-model="formStore.widget.title"
                name="title"
                :width="TextInputWidth.Full"
                :placeholder="__('widget-form-name-input-placeholder')"
            />
        </div>
        <div>
            <InputLabel for="widget-form-description-input-title">
                {{ __('widget-form-description-input-title') }}
            </InputLabel>
            <TextareaInput
                id="widget-form-description-input-title"
                v-model="formStore.widget.description"
                :placeholder="__('widget-form-description-input-placeholder')"
            />
        </div>
        <div>
            <InputLabel for="widget-form-text-input-title">
                {{ __('widget-form-text-input-title') }}
                <span class="text-error" aria-hidden="true">*</span>
            </InputLabel>
            <MarkdownTextarea
                id="widget-form-text-input-title"
                v-model="(formStore.widget as ICreateWidget<'Text'>).text"
                :placeholder="__('widget-form-text-input-placeholder')"
                :rows="6"
                required
                class="w-full"
            />
        </div>
        <p
            v-if="!(formStore.widget as ICreateWidget<'Text'>).text"
            id="widget-form-text-required-hint"
            class="text-body -mt-3"
        >
            <span class="text-error" aria-hidden="true">*</span>
            {{ __('widget-form-required-field') }}
        </p>
    </FormGroup>
</template>
